import styled from 'styled-components'

export const StyledDataContainer = styled.div`
  width: 380px;
  background: #ffffff;
  border: 0.5px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: 12px;
  padding: 24px 20px;

  &.data-container__nested {
    .data-title {
      margin-right: 0;
    }
  }
  @media screen and (max-width: 640px) {
    width: 100%;

    margin-bottom: 15px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`

export const StyledTitleContainer = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .data-title {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.textTertiary};
    margin-right: 12px;
  }

  .tooltip-wrap + .tooltip-wrap {
    margin-left: 0;
    &::before {
      content: '丨';
      color: ${({ theme }) => theme.colors.borderDefault};
      top: 1px;
      margin: 0 4px;
      position: relative;
    }
  }

  .icon-exclamation {
    cursor: pointer;
  }
  .icon-exclamation-pie {
    cursor: pointer;
    margin-left: 12px;
  }

  .middle-data-title {
    color: ${({ theme }) => theme.colors.textTertiary};
    font-size: 11px;
    font-weight: 400;
    line-height: 140%;
  }

  .sub-title {
    color: ${({ theme }) => theme.colors.textTertiary};
    font-weight: 500;
    font-size: 13px;
  }
`

export const StyledContent = styled.div`
  font-weight: bold;
  font-size: 27px;
  word-break: break-all;
  @media screen and (max-width: 640px) {
    margin-top: 12px;
  }
`
